import React, { lazy } from 'react';
import { Banana as BananaIcon, Clock3 as Clock3Icon, Egg as EggIcon, ShieldPlus as ShieldPlusIcon, WheatOff as WheatOffIcon, BoxIcon } from 'lucide-react';
const categories = [{
  icon: EggIcon,
  title: 'High-Protein Starts',
  text: 'Egg-based dishes, cottage cheese bowls, and protein-packed omelettes to protect muscle mass'
}, {
  icon: ShieldPlusIcon,
  title: 'Anti-Inflammatory Options',
  text: 'Recipes loaded with antioxidants, omega-3s, and anti-inflammatory ingredients'
}, {
  icon: WheatOffIcon,
  title: 'Gluten-Free & Low-Carb',
  text: 'For those with sensitivities or who want to reduce bloating and belly weight'
}, {
  icon: BoxIcon,
  title: 'Prep the Night Before',
  text: 'Overnight oats, chia puddings, and batch options — ready when you wake up'
}, {
  icon: BananaIcon,
  title: 'Sweet Without the Sugar Crash',
  text: 'Naturally sweetened options that satisfy cravings without spiking blood sugar'
}, {
  icon: Clock3Icon,
  title: 'Ready in 5 Minutes',
  text: 'For your busiest mornings — no excuses, just results'
}];
export function RecipeCategories() {
  return <section className="bg-cream py-20 sm:py-24" data-id="element-152">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-153">
        <div className="max-w-2xl" data-id="element-154">
          <p className="eyebrow" data-id="element-155">Inside the guide</p>
          <h2 className="section-title mt-3" data-id="element-156">
            50 recipes organized for every morning, mood, and need
          </h2>
          <p className="mt-5 leading-7 text-forest/70" data-id="element-157">
            Each category is designed around what women 50+ actually need — not
            generic &quot;healthy eating&quot; advice:
          </p>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-158">
          {categories.map(({
          icon: Icon,
          title,
          text
        }, index) => <article key={title} className="rounded-2xl border border-forest/10 bg-white p-6 transition hover:border-terracotta/40" data-id="element-159">
              <div className="flex items-start justify-between" data-id="element-160">
                <span className="text-3xl font-serif text-terracotta/60" data-id="element-161">
                  0{index + 1}
                </span>
                <span className="rounded-full bg-sage/30 p-3 text-olive" data-id="element-162">
                  <Icon size={20} data-id="element-163" />
                </span>
              </div>
              <h3 className="mt-8 text-lg font-extrabold text-forest" data-id="element-164">
                {title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-forest/70" data-id="element-165">{text}</p>
            </article>)}
        </div>

        <figure className="mt-7 overflow-hidden rounded-2xl border border-forest/10 bg-white p-2 shadow-sm" data-id="element-166">
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-167">
            <img src="https://cdn.magicpatterns.com/uploads/my3LPZWCx8S9utC11jhewD/Desayunos_8.jpg" alt="Vegetable and mushroom omelette" className="aspect-[4/3] w-full rounded-xl object-cover sm:aspect-[3/4]" loading="lazy" data-id="element-168" />
            <img src="https://cdn.magicpatterns.com/uploads/6Pz6RmXdU2tshAiFVyCDe2/Desayunos_5.jpg" alt="Strawberry and blueberry yogurt parfait" className="aspect-[4/3] w-full rounded-xl object-cover sm:aspect-[3/4]" loading="lazy" data-id="element-169" />
            <img src="https://cdn.magicpatterns.com/uploads/kMooBbVaKPH6dSniXj5spK/Desayunos_9.jpg" alt="Colorful fruit smoothies in tall glasses" className="aspect-[4/3] w-full rounded-xl object-cover sm:aspect-[3/4]" loading="lazy" data-id="element-170" />
            <img src="https://cdn.magicpatterns.com/uploads/ezcCqfPxTks7P9KcjKJE7p/Desayunos_1.jpg" alt="Yogurt bowl with banana, berries, and granola" className="aspect-[4/3] w-full rounded-xl object-cover sm:aspect-[3/4]" loading="lazy" data-id="element-171" />
          </div>
          <figcaption className="px-4 pb-2 pt-4 text-center text-sm font-semibold text-forest/75" data-id="element-172">
            A full range of satisfying mornings, all inside your guide.
          </figcaption>
        </figure>
      </div>
    </section>;
}